import styled from 'styled-components';

export const Container = styled.div`
  & > * {
    margin-bottom: 20px;
  }
`;

export const Form = styled.form`
  width: 100%;
  & > * {
    margin-bottom: 10px;
  }
  @media (min-width: 426px) {
  }
`;

export const ContainerButtonSubmit = styled.div`
  display: flex;
  align-items: center;
  & > *:first-child {
    margin-right: 10px;
  }
`;


